import { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

class RowSelectable extends Component {
  constructor(props) {
    super(props)

    this.onSelectRow = this.onSelectRow.bind(this)
    this.selectRow = this.selectRow.bind(this)
    this.unselectRow = this.unselectRow.bind(this)
    this.isSelectedRow = this.isSelectedRow.bind(this)
    this.clearSelection = this.clearSelection.bind(this)

    this.state = {
      selectedRows: [],
    }
  }

  onSelectRow(row, isSelected) {
    const callback = isSelected ? this.selectRow : this.unselectRow

    callback(row)
  }

  selectRow(row) {
    const { selectedRows } = this.state

    this.setState({ selectedRows: _.union(selectedRows, [row.id]) })
  }

  unselectRow(row) {
    const { selectedRows } = this.state

    _.remove(selectedRows, id => id === row.id)

    this.setState({ selectedRows })
  }

  isSelectedRow(row) {
    const { selectedRows } = this.state

    return !!_.find(selectedRows, id => id === row.id)
  }

  clearSelection() {
    this.setState({ selectedRows: [] })
  }

  render() {
    const { render } = this.props
    const { selectedRows } = this.state

    return render({
      selectedRows,
      onSelectRow: this.onSelectRow,
      isSelectedRow: this.isSelectedRow,
      clearSelection: this.clearSelection,
    })
  }
}

RowSelectable.propTypes = {
  render: PropTypes.func.isRequired,
}

export default RowSelectable
